import { IconMapBus16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { ETransportType } from '../../../types/geo';

interface ITimeToGetProps {
  transportType: ETransportType;
  time: number;
}

export function UndergroundTimeToGet(props: ITimeToGetProps) {
  const { transportType, time } = props;
  const Icon = transportType === ETransportType.Walk ? IconMapWalk16 : IconMapBus16;

  return (
    <>
      <div className={styles['icon']}>
        <Icon fontSize={14} />
      </div>

      <span>{time} мин.</span>
    </>
  );
}
